export const type: string = 'ogmw_standard_table'
